"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATEFORMAT = void 0;
exports.DATEFORMAT = {
    alias: 'FORMATAR_DATA',
    description: 'Formata a data escolhida para o formato informado',
    arg_names: ['data_a_formatar', 'formato', 'idioma'],
    args_description: [
        'data a ser formatada',
        'formato em que a data deve ser formatada',
        'idioma a ser usado',
    ],
    target_date_format: 'dd/MM/yyyy',
    source_date_format: 'yyyy-MM-dd',
};
